import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getRestaurantDetails } from "../actions/restaurantActions";
import SwitchOnAndOff from "../components/SwitchOnAndOff";
import Loader from "../components/Loader";
import Messages from "../components/Messages";
import styled from "styled-components";
import { PageHeaderBar, PageHeaderTitle, PageHeaderDescription } from "../components/PageHeader";
import SubMenu from "../components/SubMenu";
import {
  updateRestaurant,
  createRestaurant,
} from "../actions/restaurantActions";
import TimeInputLessPlus from "../components/TimeInputLessPlus";
import Separator from "../components/Separator";
import moment from "moment-timezone";
import DropDownButton from "../components/DropDownButton";
import {
  GoogleMap,
  Marker,
  useLoadScript,
  useJsApiLoader,
} from "@react-google-maps/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faSquarePhoneFlip } from "@fortawesome/free-solid-svg-icons";
import { getDialCode, getCountryCode } from "../components/CountryCode";
import InputDayOrHour from "../components/InputDayOrHour";
import InputDayOrHourInt from "../components/InputDayOrHourInt";
import NumberStepper, {
  StepperRule,
  StepperRuleGroup,
} from "../components/NumberStepper";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
/* global google */
import {
  Container,
  Input,
  ModernButton,
  SettingsCard as BaseSettingsCard,
  SectionTitle as BaseSectionTitle,
  Text,
  CustomSpan,
  StyledSelect,
} from "../components/DefaultImports";
import { CustomModal } from "../components/CustomModal";
import { api } from "../App";
import {
  hasAgilFeatures,
  hasCompletoFeatures,
  planTier
} from "../utils/planFeatures";
const getTimezone = () => {
  if (window.Intl && window.Intl.DateTimeFormat) {
    const options = new window.Intl.DateTimeFormat().resolvedOptions();
    return options && options.timeZone ? options.timeZone : "";
  }
  return "";
};
const getBooleanValue = (value, fallback = true) => {
  if (typeof value === "boolean") return value;
  if (value === 1 || value === "1" || value === "true") return true;
  if (value === 0 || value === "0" || value === "false") return false;
  return fallback;
};
const parseDurationHours = (value) => {
  if (typeof value === "number") return value;
  const hours = Number(String(value || "0").split(":")[0]);
  return Number.isFinite(hours) ? hours : 0;
};
function RestaurantSettingsUpdate({
  creating_restaurant = "no",
  handleNextStep = false,
  restaurant_id = false,
  restaurantCreated = false,
  setCreateRestaurantToFalse = false,
  steps = false,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const params = useParams();
  const [restaurantId, setRestaurantId] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("ok_status");
  const [showPeopleLimitUpgradeModal, setShowPeopleLimitUpgradeModal] =
    useState(false);
  const [
    showReservationExtrasUpgradeModal,
    setShowReservationExtrasUpgradeModal,
  ] = useState(false);
  const [
    showGroupSizeAcceptanceUpgradeModal,
    setShowGroupSizeAcceptanceUpgradeModal,
  ] = useState(false);
  const [showAutoAcceptanceUpgradeModal, setShowAutoAcceptanceUpgradeModal] =
    useState(false);
  const [restaurantName, setRestaurantName] = useState("");
  const [address, setAddress] = useState("");
  const [postalCode, setPostalCode] = useState(false);
  const [longitudeField, setLongitudeField] = useState(0.0);
  const [latitudeField, setLatitudeField] = useState(0.0);
  const [viewDistance, setViewDistance] = useState(18);
  const [numberOfChairs, setNumberOfChairs] = useState(0);
  const [numberOfBabyChairs, setNumberOfBabyChairs] = useState("");
  const [limitPeopleReservation, setLimitPeopleReservation] = useState("");
  const [limitBabyChairsReservation, setLimitBabyChairsReservation] =
    useState("");
  const [autoAcceptLimit, setAutoAcceptLimit] = useState("");
  const [eachTime, setEachTime] = useState("00:15");
  const [acceptPeoplePerEachTime, setAcceptPeoplePerEachTime] = useState("");
  const [timezone, setTimezone] = useState(getTimezone());
  const timezones = moment.tz.names();
  const [autoAcceptTimeLimit, setAutoAcceptTimeLimit] = useState("");
  const [autoAcceptTimeLimitFuture, setAutoAcceptTimeLimitFuture] =
    useState("");
  const [messageReminderTime, setMessageReminderTime] = useState("");
  const [autoSetTables, setAutoSetTables] = useState(null);
  const [showTableNotFreedNotification, setShowTableNotFreedNotification] =
    useState(true);
  const [hideSoupAttribution, setHideSoupAttribution] = useState(false);
  const [askPetFriendly, setAskPetFriendly] = useState(false);
  const [askBabyStroller, setAskBabyStroller] = useState(false);
  const [timeToCancelledWarning, setTimeToCancelledWarning] = useState("");
  const [
    stop_allowing_modifications_time_before_date,
    setStop_allowing_modifications_time_before_date,
  ] = useState(0);
  const [
    stop_allowing_cancelling_time_before_date,
    setStop_allowing_cancelling_time_before_date,
  ] = useState(0);
  const [countryCode, setCountryCode] = useState("pt");
  const [restaurant_description, setRestaurant_description] = useState("");
  const [reconfirmation_duration, setReconfirmation_duration] = useState("");
  const [reconfirmation_time_before_date, setReconfirmation_time_before_date] =
    useState("");
  const [sizeError, setSizeError] = useState("");
  const [restaurant_params, setRestaurant_params] = useState({});
  const [prepaymentActive, setPrepaymentActive] = useState(false);
  const [prepaymentMinPeople, setPrepaymentMinPeople] = useState(6);
  const [prepaymentChargeType, setPrepaymentChargeType] = useState("per_person");
  const [prepaymentAmount, setPrepaymentAmount] = useState("10.00");
  const [prepaymentFreeCancellationHours, setPrepaymentFreeCancellationHours] =
    useState(24);
  const [prepaymentInvoicingMode, setPrepaymentInvoicingMode] = useState("manual");
  const [stripeConnectStatus, setStripeConnectStatus] = useState(null);
  const [stripeConnectLoading, setStripeConnectLoading] = useState(false);
  const [stripeConnectError, setStripeConnectError] = useState("");
  const [moloniConnectStatus, setMoloniConnectStatus] = useState(null);
  const [moloniConnectLoading, setMoloniConnectLoading] = useState(false);
  const [moloniConnectError, setMoloniConnectError] = useState("");
  const [moloniCompanies, setMoloniCompanies] = useState([]);
  const [moloniDocumentSets, setMoloniDocumentSets] = useState([]);
  const [moloniPaymentMethods, setMoloniPaymentMethods] = useState([]);
  const [moloniProducts, setMoloniProducts] = useState([]);
  const [moloniCompanyId, setMoloniCompanyId] = useState("");
  const [moloniDocumentSetId, setMoloniDocumentSetId] = useState("");
  const [moloniPaymentMethodId, setMoloniPaymentMethodId] = useState("");
  const [moloniProductId, setMoloniProductId] = useState("");
  const [moloniProductSearch, setMoloniProductSearch] = useState("");

  // ZoneSoft POS. Only the preferences a restaurant may safely own live here.
  // The store identity (merchant serial + store number) and the callback
  // secrets are set during onboarding and are read-only or absent on purpose.
  const [zonesoftStatus, setZonesoftStatus] = useState(null);
  const [zonesoftLoading, setZonesoftLoading] = useState(false);
  const [zonesoftError, setZonesoftError] = useState("");
  const [zonesoftSaved, setZonesoftSaved] = useState(false);
  const [zonesoftEnabled, setZonesoftEnabled] = useState(false);
  const [zonesoftSyncCreate, setZonesoftSyncCreate] = useState(true);
  const [zonesoftSyncUpdate, setZonesoftSyncUpdate] = useState(true);
  const [zonesoftSyncCancel, setZonesoftSyncCancel] = useState(true);
  const [zonesoftDiscountType, setZonesoftDiscountType] = useState("");
  const [zonesoftDiscountValue, setZonesoftDiscountValue] = useState("");
  const [zonesoftPrintEnabled, setZonesoftPrintEnabled] = useState(false);
  const [zonesoftPrintTemplate, setZonesoftPrintTemplate] = useState("");
  const { isLoaded: isGoogleLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDtPooGWkj4z_ExlO9ggRMwwI9QiFZuZTI",
  });
  const [marker, setMarker] = useState(false);
  const [firstTimeChekcer, setFirstTimeChekcer] = useState(false);
  const [allowGeocode, setAllowGeocode] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setAllowGeocode(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    if (allowGeocode && postalCode && isGoogleLoaded) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode(
        {
          address: postalCode,
        },
        (results, status) => {
          if (status === "OK") {
            const location = results[0].geometry.location;
            setLatitudeField(location.lat());
            setLongitudeField(location.lng());
            setMarker({
              lat: location.lat(),
              lng: location.lng(),
            });
          } else {
            console.error(
              "Geocode was not successful for the following reason:",
              status,
            );
          }
        },
      );
    }
  }, [postalCode, isGoogleLoaded, allowGeocode]);
  const detectCountryCode = () => {
    const userCountryCode = navigator.language.split("-")[1];
    const formattedCountryCode = userCountryCode
      ? userCountryCode.toLowerCase()
      : "us";
    return formattedCountryCode;
  };
  const handleOnZoomChanged = React.useCallback((map) => {
    const zoomLevel = map.getZoom();
    setViewDistance(zoomLevel);
  }, []);
  const onMapClick = React.useCallback((event) => {
    setMarker({
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    });
    setLatitudeField(event.latLng.lat());
    setLongitudeField(event.latLng.lng());
  }, []);
  const handleOnLoad = (map) => {
    if (isGoogleLoaded) {
      google.maps.event.trigger(map, "resize");
      map.addListener("zoom_changed", () => handleOnZoomChanged(map));
    }
  };
  const restaurantDetails = useSelector((state) => state.restaurantDetails);
  const { restaurants, isLoading, error } = restaurantDetails;
  const { userInfo } = useSelector((state) => state.userLogin);
  const isPeopleLimitBlocked = !hasAgilFeatures(restaurants);
  const isReservationExtrasBlocked =
    !restaurants || planTier(restaurants?.sub_lvl) <= 1;
  const isGroupSizeAcceptanceBlocked = !hasAgilFeatures(restaurants);
  const isAutoAcceptanceBlocked = !hasAgilFeatures(restaurants);
  const isIntervalPeopleLimitBlocked = !hasCompletoFeatures(restaurants);
  // Removing the "Reservas com Soup" mark is a paid feature: the free plan is
  // paid for with the attribution.
  const isSoupAttributionBlocked = !hasAgilFeatures(restaurants);
  const displayedPeopleReservationLimit = isPeopleLimitBlocked ? "" : limitPeopleReservation;
  const generateIntervalOptions = () => {
    const intervalOptions = [];
    for (let i = 0; i < 24; i++) {
      for (let j = 0; j < 60; j += 15) {
        const hour = i.toString().padStart(2, "0");
        const minute = j.toString().padStart(2, "0");
        const time = `${hour}:${minute}`;
        if (time >= "00:15" && time <= "08:00") {
          intervalOptions.push(time);
        }
      }
    }
    return intervalOptions;
  };
  const generateNumberOptions = () => {
    const numberOptions = [];
    for (let i = 0; i < 100; i++) {
      numberOptions.push(i);
    }
    return numberOptions;
  };
  const [numberOptions, setNumberOptions] = useState(generateNumberOptions());
  const [intervalOptions, setIntervalOptions] = useState(
    generateIntervalOptions(),
  );
  let initialData;
  useEffect(() => {
    if (restaurants) {
      setRestaurantId(restaurants.id);
    }
  }, [restaurants]);

  const stripeRequestConfig = React.useMemo(
    () => ({
      headers: userInfo?.token
        ? { Authorization: `Bearer ${userInfo.token}` }
        : {},
    }),
    [userInfo?.token],
  );

  const loadStripeConnectStatus = React.useCallback(async () => {
    if (!restaurantId || creating_restaurant !== "no" || !userInfo?.token) {
      return;
    }
    setStripeConnectLoading(true);
    setStripeConnectError("");
    try {
      const { data } = await api.get(
        `/payments/connect/account-status/${restaurantId}/`,
        stripeRequestConfig,
      );
      setStripeConnectStatus(data);
      if (!data?.ready && prepaymentActive) {
        setPrepaymentActive(false);
      }
    } catch (err) {
      setStripeConnectError(
        err?.response?.data?.error ||
          err?.message ||
          t("ui.screens.restaurantSettingsUpdate.stripeStatusFailed"),
      );
    } finally {
      setStripeConnectLoading(false);
    }
  }, [
    restaurantId,
    creating_restaurant,
    userInfo?.token,
    stripeRequestConfig,
    prepaymentActive,
    t,
  ]);

  useEffect(() => {
    loadStripeConnectStatus();
  }, [loadStripeConnectStatus]);

  useEffect(() => {
    const connectResult = new URLSearchParams(location.search).get(
      "stripe_connect",
    );
    if (!connectResult) return;

    if (connectResult === "failed") {
      setStripeConnectError(
        t("ui.screens.restaurantSettingsUpdate.stripeConnectFailed"),
      );
    } else if (connectResult === "success") {
      setStripeConnectError("");
      loadStripeConnectStatus();
    }

    navigate(location.pathname, { replace: true });
  }, [location.search, location.pathname, loadStripeConnectStatus, navigate, t]);

  const handleConnectStripe = async () => {
    if (!restaurantId || !userInfo?.token) return;
    setStripeConnectLoading(true);
    setStripeConnectError("");
    try {
      const { data } = await api.post(
        `/payments/connect/oauth-url/${restaurantId}/`,
        {},
        stripeRequestConfig,
      );
      if (!data?.url) {
        throw new Error(
          t("ui.screens.restaurantSettingsUpdate.stripeConnectFailed"),
        );
      }
      window.location.href = data.url;
    } catch (err) {
      setStripeConnectError(
        err?.response?.data?.error ||
          err?.message ||
          t("ui.screens.restaurantSettingsUpdate.stripeConnectFailed"),
      );
      setStripeConnectLoading(false);
    }
  };

  const handleDisconnectStripe = async () => {
    if (
      !restaurantId ||
      !userInfo?.token ||
      !window.confirm(
        t("ui.screens.restaurantSettingsUpdate.disconnectStripeConfirm"),
      )
    ) {
      return;
    }
    setStripeConnectLoading(true);
    setStripeConnectError("");
    try {
      await api.post(
        `/payments/connect/disconnect/${restaurantId}/`,
        {},
        stripeRequestConfig,
      );
      setStripeConnectStatus({
        connected: false,
        ready: false,
        charges_enabled: false,
        payouts_enabled: false,
        details_submitted: false,
      });
      setPrepaymentActive(false);
    } catch (err) {
      setStripeConnectError(
        err?.response?.data?.error ||
          err?.message ||
          t("ui.screens.restaurantSettingsUpdate.stripeConnectFailed"),
      );
    } finally {
      setStripeConnectLoading(false);
    }
  };

  const loadMoloniOptions = React.useCallback(async (companyOverride = null, searchOverride = null) => {
    if (!restaurantId || !userInfo?.token) return;
    setMoloniConnectLoading(true);
    setMoloniConnectError("");
    try {
      const params = new URLSearchParams();
      const chosenCompany = companyOverride ?? moloniCompanyId ?? moloniConnectStatus?.company_id;
      if (chosenCompany) params.set("company_id", chosenCompany);
      const chosenSearch = searchOverride ?? moloniProductSearch;
      if (chosenSearch) params.set("product_search", chosenSearch);
      const suffix = params.toString() ? `?${params.toString()}` : "";
      const { data } = await api.get(
        `/payments/moloni/options/${restaurantId}/${suffix}`,
        stripeRequestConfig,
      );
      setMoloniCompanies(Array.isArray(data?.companies) ? data.companies : []);
      setMoloniDocumentSets(Array.isArray(data?.document_sets) ? data.document_sets : []);
      setMoloniPaymentMethods(Array.isArray(data?.payment_methods) ? data.payment_methods : []);
      setMoloniProducts(Array.isArray(data?.products) ? data.products : []);
      if (data?.company_id && !moloniCompanyId) setMoloniCompanyId(String(data.company_id));
    } catch (err) {
      setMoloniConnectError(
        err?.response?.data?.error || err?.message || t("ui.screens.restaurantSettingsUpdate.moloniLoadFailed"),
      );
    } finally {
      setMoloniConnectLoading(false);
    }
  }, [restaurantId, userInfo?.token, stripeRequestConfig, moloniCompanyId, moloniConnectStatus?.company_id, moloniProductSearch, t]);

  const loadMoloniStatus = React.useCallback(async () => {
    if (!restaurantId || creating_restaurant !== "no" || !userInfo?.token) return;
    setMoloniConnectLoading(true);
    setMoloniConnectError("");
    try {
      const { data } = await api.get(
        `/payments/moloni/account-status/${restaurantId}/`,
        stripeRequestConfig,
      );
      setMoloniConnectStatus(data);
      setMoloniCompanyId(data?.company_id ? String(data.company_id) : "");
      setMoloniDocumentSetId(data?.document_set_id ? String(data.document_set_id) : "");
      setMoloniPaymentMethodId(data?.payment_method_id ? String(data.payment_method_id) : "");
      setMoloniProductId(data?.product_id ? String(data.product_id) : "");
      if (!data?.ready && prepaymentInvoicingMode === "moloni") {
        setPrepaymentInvoicingMode("manual");
      }
      if (data?.connected) {
        try {
          const params = data?.company_id ? `?company_id=${encodeURIComponent(data.company_id)}` : "";
          const optionsResponse = await api.get(
            `/payments/moloni/options/${restaurantId}/${params}`,
            stripeRequestConfig,
          );
          const options = optionsResponse.data || {};
          setMoloniCompanies(Array.isArray(options.companies) ? options.companies : []);
          setMoloniDocumentSets(Array.isArray(options.document_sets) ? options.document_sets : []);
          setMoloniPaymentMethods(Array.isArray(options.payment_methods) ? options.payment_methods : []);
          setMoloniProducts(Array.isArray(options.products) ? options.products : []);
        } catch (optionsError) {
          console.error("Failed to load Moloni options:", optionsError);
        }
      }
    } catch (err) {
      setMoloniConnectError(
        err?.response?.data?.error || err?.message || t("ui.screens.restaurantSettingsUpdate.moloniStatusFailed"),
      );
    } finally {
      setMoloniConnectLoading(false);
    }
  }, [restaurantId, creating_restaurant, userInfo?.token, stripeRequestConfig, t]);

  useEffect(() => {
    loadMoloniStatus();
  }, [loadMoloniStatus]);

  const applyZonesoftStatus = React.useCallback((data) => {
    setZonesoftStatus(data);
    setZonesoftEnabled(Boolean(data?.enabled));
    setZonesoftSyncCreate(data?.sync_create !== false);
    setZonesoftSyncUpdate(data?.sync_update !== false);
    setZonesoftSyncCancel(data?.sync_cancel !== false);
    setZonesoftDiscountType(data?.default_discount_type || "");
    setZonesoftDiscountValue(
      data?.default_discount_value === null || data?.default_discount_value === undefined
        ? ""
        : String(data.default_discount_value),
    );
    setZonesoftPrintEnabled(Boolean(data?.print_enabled));
    setZonesoftPrintTemplate(data?.print_text_template || "");
  }, []);

  const loadZonesoftStatus = React.useCallback(async () => {
    if (!restaurantId || !userInfo?.token) return;
    setZonesoftLoading(true);
    setZonesoftError("");
    try {
      const { data } = await api.get(
        `/integrations/zonesoft/settings/${restaurantId}/`,
        stripeRequestConfig,
      );
      applyZonesoftStatus(data);
    } catch (err) {
      // A restaurant without the integration is the normal case, not an error.
      if (err?.response?.status === 403 || err?.response?.status === 404) {
        setZonesoftStatus({ linked: false });
      } else {
        setZonesoftError(
          err?.response?.data?.error ||
            err?.message ||
            t("ui.screens.restaurantSettingsUpdate.zonesoftStatusFailed"),
        );
      }
    } finally {
      setZonesoftLoading(false);
    }
  }, [restaurantId, userInfo?.token, stripeRequestConfig, applyZonesoftStatus, t]);

  useEffect(() => {
    loadZonesoftStatus();
  }, [loadZonesoftStatus]);

  const handleSaveZonesoft = async () => {
    if (!restaurantId || !userInfo?.token) return;
    setZonesoftLoading(true);
    setZonesoftError("");
    setZonesoftSaved(false);
    try {
      const { data } = await api.post(
        `/integrations/zonesoft/settings/${restaurantId}/`,
        {
          enabled: zonesoftEnabled,
          sync_create: zonesoftSyncCreate,
          sync_update: zonesoftSyncUpdate,
          sync_cancel: zonesoftSyncCancel,
          default_discount_type: zonesoftDiscountType,
          default_discount_value: zonesoftDiscountValue,
          print_enabled: zonesoftPrintEnabled,
          print_text_template: zonesoftPrintTemplate,
        },
        stripeRequestConfig,
      );
      applyZonesoftStatus(data);
      setZonesoftSaved(true);
    } catch (err) {
      const details = err?.response?.data?.details;
      setZonesoftError(
        (Array.isArray(details) && details.join(". ")) ||
          err?.response?.data?.error ||
          err?.message ||
          t("ui.screens.restaurantSettingsUpdate.zonesoftSaveFailed"),
      );
    } finally {
      setZonesoftLoading(false);
    }
  };

  useEffect(() => {
    const connectResult = new URLSearchParams(location.search).get("moloni_connect");
    if (!connectResult) return;
    if (connectResult === "failed") {
      setMoloniConnectError(t("ui.screens.restaurantSettingsUpdate.moloniConnectFailed"));
    } else if (connectResult === "success") {
      setMoloniConnectError("");
      loadMoloniStatus();
    }
    navigate(location.pathname, { replace: true });
  }, [location.search, location.pathname, loadMoloniStatus, navigate, t]);

  const handleConnectMoloni = async () => {
    if (!restaurantId || !userInfo?.token) return;
    setMoloniConnectLoading(true);
    setMoloniConnectError("");
    try {
      const { data } = await api.post(
        `/payments/moloni/oauth-url/${restaurantId}/`,
        {},
        stripeRequestConfig,
      );
      if (!data?.url) throw new Error(t("ui.screens.restaurantSettingsUpdate.moloniConnectFailed"));
      window.location.href = data.url;
    } catch (err) {
      setMoloniConnectError(
        err?.response?.data?.error || err?.message || t("ui.screens.restaurantSettingsUpdate.moloniConnectFailed"),
      );
      setMoloniConnectLoading(false);
    }
  };

  const handleDisconnectMoloni = async () => {
    if (!restaurantId || !userInfo?.token || !window.confirm(t("ui.screens.restaurantSettingsUpdate.disconnectMoloniConfirm"))) return;
    setMoloniConnectLoading(true);
    setMoloniConnectError("");
    try {
      await api.post(`/payments/moloni/disconnect/${restaurantId}/`, {}, stripeRequestConfig);
      setMoloniConnectStatus({ connected: false, ready: false });
      setMoloniCompanies([]);
      setMoloniDocumentSets([]);
      setMoloniPaymentMethods([]);
      setMoloniProducts([]);
      setMoloniCompanyId("");
      setMoloniDocumentSetId("");
      setMoloniPaymentMethodId("");
      setMoloniProductId("");
      setPrepaymentInvoicingMode("manual");
    } catch (err) {
      setMoloniConnectError(err?.response?.data?.error || err?.message || t("ui.screens.restaurantSettingsUpdate.moloniConnectFailed"));
    } finally {
      setMoloniConnectLoading(false);
    }
  };

  const handleMoloniCompanyChange = async (value) => {
    setMoloniCompanyId(value);
    setMoloniDocumentSetId("");
    setMoloniPaymentMethodId("");
    setMoloniProductId("");
    if (value) await loadMoloniOptions(value, "");
  };

  const handleSaveMoloniConfiguration = async () => {
    if (!restaurantId || !moloniCompanyId || !moloniDocumentSetId || !moloniProductId) {
      setMoloniConnectError(t("ui.screens.restaurantSettingsUpdate.moloniConfigRequired"));
      return;
    }
    setMoloniConnectLoading(true);
    setMoloniConnectError("");
    try {
      const { data } = await api.post(
        `/payments/moloni/configure/${restaurantId}/`,
        {
          company_id: moloniCompanyId,
          document_set_id: moloniDocumentSetId,
          payment_method_id: moloniPaymentMethodId || null,
          product_id: moloniProductId,
        },
        stripeRequestConfig,
      );
      setMoloniConnectStatus(data);
    } catch (err) {
      setMoloniConnectError(err?.response?.data?.error || err?.message || t("ui.screens.restaurantSettingsUpdate.moloniConfigSaveFailed"));
    } finally {
      setMoloniConnectLoading(false);
    }
  };

  const handleTestMoloni = async () => {
    if (!restaurantId) return;
    setMoloniConnectLoading(true);
    setMoloniConnectError("");
    try {
      const { data } = await api.post(`/payments/moloni/test/${restaurantId}/`, {}, stripeRequestConfig);
      setMoloniConnectStatus(data);
      window.alert(t("ui.screens.restaurantSettingsUpdate.moloniTestSuccess"));
    } catch (err) {
      setMoloniConnectError(err?.response?.data?.error || err?.message || t("ui.screens.restaurantSettingsUpdate.moloniTestFailed"));
    } finally {
      setMoloniConnectLoading(false);
    }
  };

  useEffect(() => {
    if (restaurants && restaurants !== null) {
      setRestaurantName(restaurants.restaurant_name);
      setAddress(restaurants.adress);
      if (
        restaurants.postal_code !== postalCode &&
        restaurants.postal_code !== undefined
      ) {
        setPostalCode(restaurants.postal_code);
      }
      setLatitudeField(parseFloat(restaurants.latitude));
      setLongitudeField(parseFloat(restaurants.longitude));
      setViewDistance(restaurants.view_distance);
      setMarker({
        lat: parseFloat(restaurants.latitude),
        lng: parseFloat(restaurants.longitude),
      });
      setNumberOfBabyChairs(restaurants.number_of_babychairs);
      setLimitPeopleReservation(restaurants.limit_people_reservation);
      setLimitBabyChairsReservation(restaurants.limit_baby_chairs_reservation);
      setEachTime(restaurants.each_time);
      setAutoAcceptLimit(restaurants.auto_accept_limit);
      setAcceptPeoplePerEachTime(restaurants.accept_people_per_each_time);
      setTimezone(restaurants.timezone);
      setAutoAcceptTimeLimit(restaurants.only_auto_accept_before_this_time);
      setAutoAcceptTimeLimitFuture(
        restaurants.only_auto_accept_before_this_time_future,
      );
      setMessageReminderTime(restaurants.send_message_reminder_to_customers);
      setAutoSetTables(restaurants.auto_set_tables);
      setShowTableNotFreedNotification(
        getBooleanValue(restaurants.show_table_not_freed_notification, true),
      );
      setHideSoupAttribution(
        getBooleanValue(restaurants.hide_soup_attribution, false),
      );
      setAskPetFriendly(getBooleanValue(restaurants.ask_pet_friendly, false));
      setAskBabyStroller(
        getBooleanValue(restaurants.ask_baby_stroller, false),
      );
      setTimeToCancelledWarning(restaurants.time_to_cancelled_warning);
      setRestaurant_description(restaurants.restaurant_description);
      setReconfirmation_duration(restaurants.reconfirmation_duration);
      setReconfirmation_time_before_date(
        restaurants.reconfirmation_time_before_date,
      );
      setStop_allowing_modifications_time_before_date(
        restaurants.stop_allowing_modifications_time_before_date,
      );
      setStop_allowing_cancelling_time_before_date(
        restaurants.stop_allowing_cancelling_time_before_date,
      );
      setPrepaymentActive(Boolean(restaurants.prepayment_active));
      setPrepaymentMinPeople(restaurants.prepayment_min_people ?? 6);
      setPrepaymentChargeType(
        restaurants.prepayment_charge_type || "per_person",
      );
      setPrepaymentAmount(
        ((Number(restaurants.prepayment_amount_cents) || 1000) / 100).toFixed(2),
      );
      setPrepaymentFreeCancellationHours(
        restaurants.prepayment_free_cancellation_hours ?? 24,
      );
      setPrepaymentInvoicingMode(
        restaurants.prepayment_invoicing_mode || "manual",
      );
      initialData = {
        restaurantName: restaurants?.restaurant_name,
        address: restaurants?.address,
        postalCode: restaurants?.postal_code,
        latitudeField: parseFloat(restaurants?.latitude),
        longitudeField: parseFloat(restaurants?.longitude),
        viewDistance: restaurants?.view_distance,
        numberOfBabyChairs: restaurants?.number_of_babychairs,
        limitPeopleReservation: restaurants?.limit_people_reservation,
        limitBabyChairsReservation: restaurants?.limit_baby_chairs_reservation,
        eachTime: restaurants?.each_time,
        autoAcceptLimit: restaurants?.auto_accept_limit,
        acceptPeoplePerEachTime: restaurants?.accept_people_per_each_time,
        timezone: restaurants?.timezone,
        autoAcceptTimeLimit: restaurants?.only_auto_accept_before_this_time,
        autoAcceptTimeLimitFuture:
          restaurants?.only_auto_accept_before_this_time_future,
        messageReminderTime: restaurants?.send_message_reminder_to_customers,
        autoSetTables: restaurants?.auto_set_tables,
        showTableNotFreedNotification:
          restaurants?.show_table_not_freed_notification,
        hideSoupAttribution: restaurants?.hide_soup_attribution,
        askPetFriendly: restaurants?.ask_pet_friendly,
        askBabyStroller: restaurants?.ask_baby_stroller,
        timeToCancelledWarning: restaurants?.time_to_cancelled_warning,
        restaurant_description: restaurants?.restaurant_description,
        reconfirmation_duration: restaurants?.reconfirmation_duration,
        reconfirmation_time_before_date:
          restaurants?.reconfirmation_time_before_date,
        stop_allowing_modifications_time_before_date:
          restaurants?.stop_allowing_modifications_time_before_date,
        stop_allowing_cancelling_time_before_date:
          restaurants?.stop_allowing_cancelling_time_before_date,
        prepaymentActive: Boolean(restaurants?.prepayment_active),
        prepaymentMinPeople: restaurants?.prepayment_min_people ?? 6,
        prepaymentChargeType:
          restaurants?.prepayment_charge_type || "per_person",
        prepaymentAmount: (
          (Number(restaurants?.prepayment_amount_cents) || 1000) / 100
        ).toFixed(2),
        prepaymentFreeCancellationHours:
          restaurants?.prepayment_free_cancellation_hours ?? 24,
        prepaymentInvoicingMode:
          restaurants?.prepayment_invoicing_mode || "manual",
      };
    }
  }, [restaurants, restaurant_id]);
  const hasChanges = () => {
    const currentData = {
      restaurantName,
      address,
      postalCode,
      latitudeField,
      longitudeField,
      viewDistance,
      numberOfBabyChairs,
      limitPeopleReservation,
      limitBabyChairsReservation,
      eachTime,
      autoAcceptLimit,
      acceptPeoplePerEachTime,
      timezone,
      autoAcceptTimeLimit,
      autoAcceptTimeLimitFuture,
      messageReminderTime,
      autoSetTables,
      showTableNotFreedNotification,
      askPetFriendly,
      askBabyStroller,
      timeToCancelledWarning,
      restaurant_description,
      reconfirmation_duration,
      reconfirmation_time_before_date,
      stop_allowing_modifications_time_before_date,
      stop_allowing_cancelling_time_before_date,
      prepaymentActive,
      prepaymentMinPeople,
      prepaymentChargeType,
      prepaymentAmount,
      prepaymentFreeCancellationHours,
      prepaymentInvoicingMode,
    };
    const originalData = {
      restaurantName: restaurants?.restaurant_name,
      address: restaurants?.adress,
      postalCode: restaurants?.postal_code,
      latitudeField: parseFloat(restaurants?.latitude),
      longitudeField: parseFloat(restaurants?.longitude),
      viewDistance: restaurants?.view_distance,
      numberOfBabyChairs: restaurants?.number_of_babychairs,
      limitPeopleReservation: restaurants?.limit_people_reservation,
      limitBabyChairsReservation: restaurants?.limit_baby_chairs_reservation,
      eachTime: restaurants?.each_time,
      autoAcceptLimit: restaurants?.auto_accept_limit,
      acceptPeoplePerEachTime: restaurants?.accept_people_per_each_time,
      timezone: restaurants?.timezone,
      autoAcceptTimeLimit: restaurants?.only_auto_accept_before_this_time,
      autoAcceptTimeLimitFuture:
        restaurants?.only_auto_accept_before_this_time_future,
      messageReminderTime: restaurants?.send_message_reminder_to_customers,
      autoSetTables: restaurants?.auto_set_tables,
      showTableNotFreedNotification: getBooleanValue(
        restaurants?.show_table_not_freed_notification,
        true,
      ),
      hideSoupAttribution: getBooleanValue(
        restaurants?.hide_soup_attribution,
        false,
      ),
      timeToCancelledWarning: restaurants?.time_to_cancelled_warning,
      restaurant_description: restaurants?.restaurant_description,
      reconfirmation_duration: restaurants?.reconfirmation_duration,
      reconfirmation_time_before_date:
        restaurants?.reconfirmation_time_before_date,
      stop_allowing_modifications_time_before_date:
        restaurants?.stop_allowing_modifications_time_before_date,
      stop_allowing_cancelling_time_before_date:
        restaurants?.stop_allowing_cancelling_time_before_date,
      prepaymentActive: Boolean(restaurants?.prepayment_active),
      prepaymentMinPeople: restaurants?.prepayment_min_people ?? 6,
      prepaymentChargeType:
        restaurants?.prepayment_charge_type || "per_person",
      prepaymentAmount: (
        (Number(restaurants?.prepayment_amount_cents) || 1000) / 100
      ).toFixed(2),
      prepaymentFreeCancellationHours:
        restaurants?.prepayment_free_cancellation_hours ?? 24,
      prepaymentInvoicingMode:
        restaurants?.prepayment_invoicing_mode || "manual",
    };
    return Object.keys(currentData).some(
      (key) =>
        JSON.stringify(currentData[key]) !== JSON.stringify(originalData[key]),
    );
  };
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (hasChanges()) {
        event.preventDefault();
        event.returnValue = t("ui.i18nMessages.unsavedChangesLeave");
      }
    };
    const handleNavigation = (event) => {
      if (hasChanges()) {
        event.preventDefault();
        const confirmLeave = window.confirm(
          t("ui.i18nMessages.unsavedChangesLeave"),
        );
        if (confirmLeave) {
          window.removeEventListener("beforeunload", handleBeforeUnload);
          navigate(event.detail.to);
        }
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("customNavigation", handleNavigation);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("customNavigation", handleNavigation);
    };
  }, [
    restaurantName,
    address,
    postalCode,
    latitudeField,
    longitudeField,
    viewDistance,
    numberOfBabyChairs,
    limitPeopleReservation,
    limitBabyChairsReservation,
    eachTime,
    autoAcceptLimit,
    acceptPeoplePerEachTime,
    timezone,
    autoAcceptTimeLimit,
    autoAcceptTimeLimitFuture,
    messageReminderTime,
    autoSetTables,
    showTableNotFreedNotification,
    hideSoupAttribution,
    timeToCancelledWarning,
    restaurant_description,
    reconfirmation_duration,
    reconfirmation_time_before_date,
    stop_allowing_modifications_time_before_date,
    stop_allowing_cancelling_time_before_date,
    prepaymentActive,
    prepaymentMinPeople,
    prepaymentChargeType,
    prepaymentAmount,
    prepaymentFreeCancellationHours,
    prepaymentInvoicingMode,
  ]);
  function checkEmptyStates() {
    let emptyStates = [];
    if (restaurantName === "") {
      emptyStates.push(t("ui.i18nFinalCleanup.restaurantName"));
    }
    if (!address) {
      emptyStates.push(t("ui.i18nFinalCleanup.address"));
    }
    if (numberOfBabyChairs === "") {
      emptyStates.push(t("ui.i18nFinalCleanup.numberOfBabyChairs"));
    }
    if (!isPeopleLimitBlocked && !limitPeopleReservation) {
      emptyStates.push(t("ui.i18nFinalCleanup.peoplePerReservationLimit"));
    }
    if (!limitBabyChairsReservation) {
      emptyStates.push(t("ui.i18nFinalCleanup.babyChairsPerReservationLimit"));
    }
    if (autoAcceptLimit < 0) {
      emptyStates.push(t("ui.i18nFinalCleanup.automaticAcceptance"));
    }
    if (!eachTime) {
      emptyStates.push(t("ui.i18nFinalCleanup.timeInterval"));
    }
    if (!isIntervalPeopleLimitBlocked && !acceptPeoplePerEachTime) {
      emptyStates.push(t("ui.i18nFinalCleanup.peoplePerSlotLimit"));
    }
    if (prepaymentActive) {
      if (!stripeConnectStatus?.ready) {
        emptyStates.push(
          t("ui.screens.restaurantSettingsUpdate.stripeAccount"),
        );
      }
      if (Number(prepaymentMinPeople) < 1) {
        emptyStates.push(
          t("ui.screens.restaurantSettingsUpdate.prepaymentMinPeople"),
        );
      }
      if (!(Number(prepaymentAmount) > 0)) {
        emptyStates.push(
          t("ui.screens.restaurantSettingsUpdate.prepaymentAmount"),
        );
      }
      if (Number(prepaymentFreeCancellationHours) < 0) {
        emptyStates.push(
          t("ui.screens.restaurantSettingsUpdate.freeCancellationUntil"),
        );
      }
    }
    if (emptyStates.length > 0) {
      return t("ui.i18nFinalCleanup.invalidFields", {
        fields: emptyStates.join(", "),
      });
    }
    return "ok_status";
  }
  function checkForErrorsAndCreateRestaurant() {
    let status_error = checkEmptyStates();
    setErrorMessage(status_error);
    if (status_error === "ok_status") {
      setShowError(false);
      setSizeError("");
      const updatedRestaurantParams = {
        restaurant_name: restaurantName,
        adress: address,
        postal_code: postalCode,
        latitude: latitudeField,
        longitude: longitudeField,
        view_distance: viewDistance,
        number_of_chairs: numberOfChairs,
        number_of_babychairs: numberOfBabyChairs,
        limit_people_reservation:
          creating_restaurant === "no" && isPeopleLimitBlocked
            ? restaurants?.limit_people_reservation
            : limitPeopleReservation,
        limit_baby_chairs_reservation: limitBabyChairsReservation,
        auto_accept_limit: isGroupSizeAcceptanceBlocked
          ? restaurants?.auto_accept_limit
          : autoAcceptLimit,
        accept_people_per_each_time:
          creating_restaurant === "no" && isIntervalPeopleLimitBlocked
            ? restaurants?.accept_people_per_each_time
            : acceptPeoplePerEachTime,
        each_time: eachTime,
        timezone: timezone,
        only_auto_accept_before_this_time: isAutoAcceptanceBlocked
          ? restaurants?.only_auto_accept_before_this_time
          : autoAcceptTimeLimit,
        only_auto_accept_before_this_time_future: isAutoAcceptanceBlocked
          ? restaurants?.only_auto_accept_before_this_time_future
          : autoAcceptTimeLimitFuture,
        send_message_reminder_to_customers: messageReminderTime,
        auto_set_tables: autoSetTables,
        show_table_not_freed_notification: showTableNotFreedNotification,
        // Only a paying restaurant may hide the mark. On Essencial the stored
        // value is sent back untouched, so a restaurant that paid, hid it and
        // later downgraded keeps its choice for when it comes back.
        hide_soup_attribution: isSoupAttributionBlocked
          ? restaurants?.hide_soup_attribution
          : hideSoupAttribution,
        ask_pet_friendly: askPetFriendly,
        ask_baby_stroller: askBabyStroller,
        time_to_cancelled_warning: timeToCancelledWarning,
        restaurant_description: restaurant_description,
        reconfirmation_duration: reconfirmation_duration,
        reconfirmation_time_before_date: reconfirmation_time_before_date,
        stop_allowing_modifications_time_before_date:
          stop_allowing_modifications_time_before_date,
        stop_allowing_cancelling_time_before_date:
          stop_allowing_cancelling_time_before_date,
        prepayment_active: prepaymentActive,
        prepayment_min_people: Math.max(1, Number(prepaymentMinPeople) || 1),
        prepayment_charge_type: prepaymentChargeType,
        prepayment_amount_cents: Math.max(
          0,
          Math.round((Number(prepaymentAmount) || 0) * 100),
        ),
        prepayment_free_cancellation_hours: Math.max(
          0,
          Number(prepaymentFreeCancellationHours) || 0,
        ),
        // The Moloni option stays disabled until the restaurant has its own
        // Moloni connection. Preserve the stored mode rather than silently
        // rewriting it when another setting is saved.
        prepayment_invoicing_mode: prepaymentInvoicingMode,
      };
      if (creating_restaurant === "no") {
        dispatch(updateRestaurant(restaurantId, updatedRestaurantParams));
        if (steps) {
          setCreateRestaurantToFalse();
          handleNextStep();
        }
      } else {
        dispatch(createRestaurant(updatedRestaurantParams));
        setCreateRestaurantToFalse();
        handleNextStep();
      }
    } else {
      setShowError(true);
    }
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    checkForErrorsAndCreateRestaurant();
  };
  useEffect(() => {
    if (restaurantCreated === true) {
      checkForErrorsAndCreateRestaurant();
    }
  }, [restaurantCreated]);
  useEffect(() => {
    setRestaurant_params({
      restaurant_name: restaurantName,
      adress: address,
      postal_code: postalCode,
      latitude: latitudeField,
      longitude: longitudeField,
      view_distance: viewDistance,
      number_of_chairs: numberOfChairs,
      number_of_babychairs: numberOfBabyChairs,
      limit_people_reservation: limitPeopleReservation,
      limit_baby_chairs_reservation: limitBabyChairsReservation,
      accept_people_per_each_time: acceptPeoplePerEachTime,
      each_time: eachTime,
      only_auto_accept_before_this_time: autoAcceptTimeLimit,
      auto_set_tables: autoSetTables,
      show_table_not_freed_notification: showTableNotFreedNotification,
      hide_soup_attribution: hideSoupAttribution,
      ask_pet_friendly: askPetFriendly,
      ask_baby_stroller: askBabyStroller,
      time_to_cancelled_warning: timeToCancelledWarning,
      prepayment_active: prepaymentActive,
      prepayment_min_people: prepaymentMinPeople,
      prepayment_charge_type: prepaymentChargeType,
      prepayment_amount_cents: Math.round((Number(prepaymentAmount) || 0) * 100),
      prepayment_free_cancellation_hours: prepaymentFreeCancellationHours,
      prepayment_invoicing_mode: prepaymentInvoicingMode,
    });
  }, [
    dispatch,
    restaurantName,
    address,
    postalCode,
    latitudeField,
    longitudeField,
    viewDistance,
    numberOfChairs,
    numberOfBabyChairs,
    limitPeopleReservation,
    limitBabyChairsReservation,
    autoAcceptTimeLimit,
    eachTime,
    acceptPeoplePerEachTime,
    autoSetTables,
    showTableNotFreedNotification,
    hideSoupAttribution,
    timeToCancelledWarning,
    prepaymentActive,
    prepaymentMinPeople,
    prepaymentChargeType,
    prepaymentAmount,
    prepaymentFreeCancellationHours,
    prepaymentInvoicingMode,
  ]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    const numericValue = Number(value);
    switch (name) {
      case "restaurant_name":
        setRestaurantName(value);
        break;
      case "adress":
        setAddress(value);
        break;
      case "postalCode":
        setPostalCode(value);
        break;
      case "number_of_chairs":
        setNumberOfChairs(numericValue);
        break;
      case "number_of_babychairs":
        setNumberOfBabyChairs(numericValue);
        break;
      case "limit_people_reservation":
        if (numericValue > acceptPeoplePerEachTime) {
          setSizeError(t("ui.i18nFinalCleanup.groupLimitAboveSlotLimit"));
        } else {
          setSizeError("");
        }
        setLimitPeopleReservation(numericValue);
        break;
      case "limit_baby_chairs_reservation":
        setLimitBabyChairsReservation(numericValue);
        break;
      case "auto_accept_limit":
        if (isGroupSizeAcceptanceBlocked) {
          setShowGroupSizeAcceptanceUpgradeModal(true);
          return;
        }
        setAutoAcceptLimit(numericValue);
        break;
      case "accept_people_per_each_time":
        if (numericValue < limitPeopleReservation) {
          setSizeError(t("ui.i18nFinalCleanup.slotLimitBelowGroupLimit"));
        } else {
          setSizeError("");
        }
        setAcceptPeoplePerEachTime(numericValue);
        break;
      case "each_time":
        setEachTime(numericValue);
        break;
      default:
        break;
    }
  };
  const handleIntervalTimeChange = (option) => {
    setEachTime(option);
  };
  const handleTimeCancelWarning = (value) => {
    setTimeToCancelledWarning(value);
  };
  const handleAutoAcceptTimeLimit = (value) => {
    setAutoAcceptTimeLimit(value);
  };
  const handleReconfirmation_time_before_date = (value) => {
    setReconfirmation_time_before_date(value);
  };
  const handleReconfirmation = (value) => {
    setReconfirmation_duration(value);
  };
  const handleMessageReminderTime = (value) => {
    setMessageReminderTime(value);
  };
  useEffect(() => {
    if (restaurants) {
      console.log(
        "latitude: ",
        restaurants.latitude,
        "longitude: ",
        restaurants.longitude,
      );
      console.log(
        "latitudeField: ",
        latitudeField,
        "longitudeField: ",
        longitudeField,
      );
    }
  }, [restaurants]);
  return (
    <Container>
      <SettingsPageHeader>
        <SettingsPageTitle>
          {t("ui.screens.restaurantSettingsUpdate.definicoes")}
        </SettingsPageTitle>
        <SettingsPageDescription>
          {t("ui.screens.restaurantSettingsUpdate.limitacoesApenasCliente")}
        </SettingsPageDescription>
      </SettingsPageHeader>

      {isLoading ? (
        <Loader />
      ) : error ? (
        <Messages variant="error">{error}</Messages>
      ) : restaurants ? (
        <Form onSubmit={handleSubmit}>

              <SettingsGrid>
                <SettingsCard
                  data-setup-tour="settings"
                  data-size-settings-card="true"
                >
                  <SectionTitle>
                    {t(
                      "ui.screens.restaurantSettingsUpdate.tamanhoMaximoDeGrupos",
                    )}
                  </SectionTitle>

                  <SettingControlRow>
                    <SettingCopy>
                      <SettingLabel>
                        {t(
                          "ui.screens.restaurantSettingsUpdate.numeroMaximoDePessoasPorReserva",
                        )}
                      </SettingLabel>
                      <DescriptionLine>
                        {t(
                          "ui.screens.restaurantSettingsUpdate.clientesNaoPoderaoFazerReservasParaGruposMaiores",
                        )}
                      </DescriptionLine>
                    </SettingCopy>

                    <BlockedFieldWrapper $blocked={isPeopleLimitBlocked}>
                      <NumberStepper
                        value={displayedPeopleReservationLimit}
                        onChange={(value) =>
                          handleChange({
                            target: {
                              name: "limit_people_reservation",
                              value,
                            },
                          })
                        }
                        min={0}
                        max={100}
                        disabled={isPeopleLimitBlocked}
                        displayEmpty={isPeopleLimitBlocked}
                      />

                      {isPeopleLimitBlocked && (
                        <BlockedFieldOverlay
                          data-blocked-field-overlay="true"
                          role="button"
                          tabIndex={0}
                          aria-label={t(
                            "ui.screens.restaurantSettingsUpdate.atualizarOPlanoParaConfigurarO",
                          )}
                          onClick={() => setShowPeopleLimitUpgradeModal(true)}
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              setShowPeopleLimitUpgradeModal(true);
                            }
                          }}
                        >
                          <FontAwesomeIcon icon={faLock} />
                        </BlockedFieldOverlay>
                      )}
                    </BlockedFieldWrapper>

                    <SettingUnit>
                      {t("ui.screens.restaurantSettingsUpdate.pessoas")}
                    </SettingUnit>
                  </SettingControlRow>
                </SettingsCard>

                <SettingsCard data-auto-settings-card="true">
                  <SectionTitle>
                    {t(
                      "ui.screens.restaurantSettingsUpdate.aceitacaoAutomatica",
                    )}
                  </SectionTitle>

                  <SettingsIntro>
                    {t("ui.restaurantSetupWizard.definitions.autoAccept.body")}
                  </SettingsIntro>

                  <StepperRuleGroup>
                    <StepperRule>
                      <span>
                        {t(
                          "ui.restaurantSetupWizard.definitions.autoAccept.upTo",
                        )}
                      </span>
                      <BlockedFieldWrapper
                        $blocked={isGroupSizeAcceptanceBlocked}
                      >
                        <NumberStepper
                          value={autoAcceptLimit}
                          onChange={(value) => setAutoAcceptLimit(value)}
                          min={0}
                          max={100}
                          disabled={isGroupSizeAcceptanceBlocked}
                          displayEmpty={isGroupSizeAcceptanceBlocked}
                        />
                        {isGroupSizeAcceptanceBlocked && (
                          <BlockedFieldOverlay
                            data-blocked-field-overlay="true"
                            role="button"
                            tabIndex={0}
                            aria-label={t(
                              "ui.screens.restaurantSettingsUpdate.atualizarOPlanoParaEscolherAceitacao",
                            )}
                            onClick={() =>
                              setShowGroupSizeAcceptanceUpgradeModal(true)
                            }
                            onKeyDown={(event) => {
                              if (event.key === "Enter" || event.key === " ") {
                                event.preventDefault();
                                setShowGroupSizeAcceptanceUpgradeModal(true);
                              }
                            }}
                          >
                            <FontAwesomeIcon icon={faLock} />
                          </BlockedFieldOverlay>
                        )}
                      </BlockedFieldWrapper>
                      <span>
                        {t("ui.restaurantSetupWizard.definitionUnits.people")}
                      </span>
                    </StepperRule>

                    <StepperRule>
                      <span>
                        {t(
                          "ui.restaurantSetupWizard.definitions.autoAccept.lessThan",
                        )}
                      </span>
                      <BlockedFieldWrapper $blocked={isAutoAcceptanceBlocked}>
                        <NumberStepper
                          value={Math.max(
                            0,
                            Math.round(
                              Number(autoAcceptTimeLimitFuture || 0) / 24,
                            ),
                          )}
                          onChange={(value) =>
                            setAutoAcceptTimeLimitFuture(value * 24)
                          }
                          min={0}
                          max={365}
                          disabled={isAutoAcceptanceBlocked}
                          displayEmpty={isAutoAcceptanceBlocked}
                        />
                        {isAutoAcceptanceBlocked && (
                          <BlockedFieldOverlay
                            data-blocked-field-overlay="true"
                            role="button"
                            tabIndex={0}
                            aria-label={t(
                              "ui.screens.restaurantSettingsUpdate.atualizarOPlanoParaConfigurarA2",
                            )}
                            onClick={() =>
                              setShowAutoAcceptanceUpgradeModal(true)
                            }
                            onKeyDown={(event) => {
                              if (event.key === "Enter" || event.key === " ") {
                                event.preventDefault();
                                setShowAutoAcceptanceUpgradeModal(true);
                              }
                            }}
                          >
                            <FontAwesomeIcon icon={faLock} />
                          </BlockedFieldOverlay>
                        )}
                      </BlockedFieldWrapper>
                      <span>
                        {t("ui.restaurantSetupWizard.definitionUnits.days")}
                      </span>
                    </StepperRule>

                    <StepperRule>
                      <span>
                        {t(
                          "ui.restaurantSetupWizard.definitions.autoAccept.moreThan",
                        )}
                      </span>
                      <BlockedFieldWrapper $blocked={isAutoAcceptanceBlocked}>
                        <NumberStepper
                          value={parseDurationHours(autoAcceptTimeLimit)}
                          onChange={(value) =>
                            handleAutoAcceptTimeLimit(
                              `${String(value).padStart(2, "0")}:00`,
                            )
                          }
                          min={0}
                          max={720}
                          disabled={isAutoAcceptanceBlocked}
                          displayEmpty={isAutoAcceptanceBlocked}
                        />
                        {isAutoAcceptanceBlocked && (
                          <BlockedFieldOverlay
                            data-blocked-field-overlay="true"
                            role="button"
                            tabIndex={0}
                            aria-label={t(
                              "ui.screens.restaurantSettingsUpdate.atualizarOPlanoParaConfigurarA",
                            )}
                            onClick={() =>
                              setShowAutoAcceptanceUpgradeModal(true)
                            }
                            onKeyDown={(event) => {
                              if (event.key === "Enter" || event.key === " ") {
                                event.preventDefault();
                                setShowAutoAcceptanceUpgradeModal(true);
                              }
                            }}
                          >
                            <FontAwesomeIcon icon={faLock} />
                          </BlockedFieldOverlay>
                        )}
                      </BlockedFieldWrapper>
                      <span>
                        {t("ui.restaurantSetupWizard.definitionUnits.hours")}
                      </span>
                    </StepperRule>
                  </StepperRuleGroup>
                </SettingsCard>

                {/*                 <SettingsCard>
                  <SectionTitle>
                    {t(
                      "ui.screens.restaurantSettingsUpdate.edicaoECancelamento",
                    )}
                  </SectionTitle>

                  <Text>
                    {t(
                      "ui.screens.restaurantSettingsUpdate.permitirEdicoesAte",
                    )}
                    <CustomSpan />
                    <InputDayOrHourInt
                      initialValue={
                        restaurants.stop_allowing_modifications_time_before_date
                      }
                      setValue={setStop_allowing_modifications_time_before_date}
                    />
                    <CustomSpan />
                    {t(
                      "ui.screens.restaurantSettingsUpdate.antesDaHoraMarcada",
                    )}
                    <DescriptionLine>
                      {t(
                        "ui.screens.restaurantSettingsUpdate.naoSeraPermitidoFazerEdicoesMaisPertoDaHoraMarcada",
                      )}
                    </DescriptionLine>
                  </Text>

                  <Text>
                    {t(
                      "ui.screens.restaurantSettingsUpdate.permitirCancelamentosAte",
                    )}
                    <CustomSpan />
                    <InputDayOrHourInt
                      initialValue={
                        restaurants.stop_allowing_cancelling_time_before_date
                      }
                      setValue={setStop_allowing_cancelling_time_before_date}
                    />
                    <CustomSpan />
                    {t(
                      "ui.screens.restaurantSettingsUpdate.antesDaHoraMarcada",
                    )}
                    <DescriptionLine>
                      {t(
                        "ui.screens.restaurantSettingsUpdate.cancelamentosMaisPertoDaHoraNaoSeraoAceites",
                      )}
                    </DescriptionLine>
                  </Text>
                </SettingsCard> */}

                {creating_restaurant === "no" && (
                  <SettingsCard data-wide-settings-card="true">
                    <SectionTitle>
                      {t(
                        "ui.screens.restaurantSettingsUpdate.prepaymentTitle",
                      )}
                    </SectionTitle>

                    <DescriptionLine style={{ marginBottom: 0 }}>
                      {t(
                        "ui.screens.restaurantSettingsUpdate.prepaymentDescription",
                      )}
                    </DescriptionLine>

                    <StripeConnectionPanel>
                      <div>
                        <strong>
                          {t(
                            "ui.screens.restaurantSettingsUpdate.stripeAccount",
                          )}
                        </strong>
                        <StripeStatusText
                          $ready={stripeConnectStatus?.ready}
                          $connected={stripeConnectStatus?.connected}
                        >
                          {stripeConnectLoading
                            ? t(
                                "ui.screens.restaurantSettingsUpdate.checkingStripe",
                              )
                            : stripeConnectStatus?.ready
                              ? t(
                                  "ui.screens.restaurantSettingsUpdate.stripeConnectedReady",
                                )
                              : stripeConnectStatus?.connected
                                ? t(
                                    "ui.screens.restaurantSettingsUpdate.stripeConnectedIncomplete",
                                  )
                                : t(
                                    "ui.screens.restaurantSettingsUpdate.stripeNotConnected",
                                  )}
                        </StripeStatusText>
                        {stripeConnectStatus?.email && (
                          <DescriptionLine>
                            {stripeConnectStatus.email}
                          </DescriptionLine>
                        )}
                      </div>

                      <StripeButtonRow>
                        {stripeConnectStatus?.connected ? (
                          <SecondaryStripeButton
                            type="button"
                            onClick={handleDisconnectStripe}
                            disabled={stripeConnectLoading}
                          >
                            {t(
                              "ui.screens.restaurantSettingsUpdate.disconnectStripe",
                            )}
                          </SecondaryStripeButton>
                        ) : (
                          <ModernButton
                            type="button"
                            color="#635bff"
                            fontSize="11px"
                            onClick={handleConnectStripe}
                            disabled={stripeConnectLoading}
                          >
                            {t(
                              "ui.screens.restaurantSettingsUpdate.connectStripe",
                            )}
                          </ModernButton>
                        )}
                      </StripeButtonRow>
                    </StripeConnectionPanel>

                    {stripeConnectError && (
                      <StripeErrorText>{stripeConnectError}</StripeErrorText>
                    )}

                    <ToggleRow style={{ marginTop: "16px" }}>
                      <SwitchSlot>
                        <SwitchOnAndOff
                          isOn={prepaymentActive}
                          handleToggle={() => {
                            if (!stripeConnectStatus?.ready) {
                              setStripeConnectError(
                                t(
                                  "ui.screens.restaurantSettingsUpdate.stripeNotConnected",
                                ),
                              );
                              return;
                            }
                            setStripeConnectError("");
                            setPrepaymentActive(!prepaymentActive);
                          }}
                        />
                      </SwitchSlot>
                      <ToggleText>
                        {t(
                          "ui.screens.restaurantSettingsUpdate.prepaymentToggle",
                        )}
                      </ToggleText>
                    </ToggleRow>

                    <PrepaymentFields $disabled={!stripeConnectStatus?.ready}>
                      <Text>
                        {t(
                          "ui.screens.restaurantSettingsUpdate.prepaymentMinPeople",
                        )}
                        <CustomSpan />
                        <Input
                          type="number"
                          min={1}
                          value={prepaymentMinPeople}
                          disabled={!stripeConnectStatus?.ready}
                          onChange={(e) =>
                            setPrepaymentMinPeople(e.target.value)
                          }
                        />
                        <CustomSpan />
                        {t(
                          "ui.screens.restaurantSettingsUpdate.prepaymentPeople",
                        )}
                      </Text>

                      <Text>
                        {t(
                          "ui.screens.restaurantSettingsUpdate.prepaymentChargeType",
                        )}
                        <CustomSpan />
                        <StyledSelect
                          value={prepaymentChargeType}
                          disabled={!stripeConnectStatus?.ready}
                          onChange={(e) =>
                            setPrepaymentChargeType(e.target.value)
                          }
                        >
                          <option value="per_person">
                            {t(
                              "ui.screens.restaurantSettingsUpdate.perPerson",
                            )}
                          </option>
                          <option value="fixed">
                            {t(
                              "ui.screens.restaurantSettingsUpdate.fixedAmount",
                            )}
                          </option>
                        </StyledSelect>
                      </Text>

                      <Text>
                        {t(
                          "ui.screens.restaurantSettingsUpdate.prepaymentAmount",
                        )}
                        <CustomSpan />
                        <Input
                          type="number"
                          min="0.50"
                          step="0.01"
                          value={prepaymentAmount}
                          disabled={!stripeConnectStatus?.ready}
                          onChange={(e) => setPrepaymentAmount(e.target.value)}
                        />
                        <CurrencySuffix>€</CurrencySuffix>
                        <DescriptionLine>
                          {prepaymentChargeType === "per_person"
                            ? t(
                                "ui.screens.restaurantSettingsUpdate.perPerson",
                              )
                            : t(
                                "ui.screens.restaurantSettingsUpdate.fixedAmount",
                              )}
                        </DescriptionLine>
                      </Text>

                      <Text>
                        {t(
                          "ui.screens.restaurantSettingsUpdate.freeCancellationUntil",
                        )}
                        <CustomSpan />
                        <Input
                          type="number"
                          min={0}
                          value={prepaymentFreeCancellationHours}
                          disabled={!stripeConnectStatus?.ready}
                          onChange={(e) =>
                            setPrepaymentFreeCancellationHours(e.target.value)
                          }
                        />
                        <CustomSpan />
                        {t(
                          "ui.screens.restaurantSettingsUpdate.hoursBeforeReservation",
                        )}
                      </Text>
                    </PrepaymentFields>

                    <BillingModeBlock>
                      <BillingModeTitle>
                        {t(
                          "ui.screens.restaurantSettingsUpdate.prepaymentInvoicingTitle",
                        )}
                      </BillingModeTitle>

                      <BillingModeOption>
                        <input
                          type="radio"
                          name="prepayment_invoicing_mode"
                          value="manual"
                          checked={prepaymentInvoicingMode === "manual"}
                          onChange={() => setPrepaymentInvoicingMode("manual")}
                        />
                        <span>
                          {t(
                            "ui.screens.restaurantSettingsUpdate.prepaymentInvoicingManual",
                          )}
                        </span>
                      </BillingModeOption>

                      <BillingModeOption $disabled={!moloniConnectStatus?.ready}>
                        <input
                          type="radio"
                          name="prepayment_invoicing_mode"
                          value="moloni"
                          checked={prepaymentInvoicingMode === "moloni"}
                          disabled={!moloniConnectStatus?.ready}
                          onChange={() => setPrepaymentInvoicingMode("moloni")}
                        />
                        <span>
                          {t(
                            "ui.screens.restaurantSettingsUpdate.prepaymentInvoicingMoloni",
                          )}
                          {!moloniConnectStatus?.ready && <small>
                            {t(
                              "ui.screens.restaurantSettingsUpdate.prepaymentMoloniNeedsRestaurantConnection",
                            )}
                          </small>}
                        </span>
                      </BillingModeOption>

                      <MoloniConnectionPanel>
                        <div style={{ minWidth: 0, flex: 1 }}>
                          <strong>{t("ui.screens.restaurantSettingsUpdate.moloniConnectionTitle")}</strong>
                          <StripeStatusText
                            $connected={Boolean(moloniConnectStatus?.connected)}
                            $ready={Boolean(moloniConnectStatus?.ready)}
                          >
                            {moloniConnectStatus?.ready
                              ? t("ui.screens.restaurantSettingsUpdate.moloniReady")
                              : moloniConnectStatus?.connected
                                ? t("ui.screens.restaurantSettingsUpdate.moloniNeedsConfiguration")
                                : t("ui.screens.restaurantSettingsUpdate.moloniNotConnected")}
                          </StripeStatusText>
                        </div>
                        <StripeButtonRow>
                          {moloniConnectStatus?.connected ? (
                            <SecondaryStripeButton
                              type="button"
                              disabled={moloniConnectLoading}
                              onClick={handleDisconnectMoloni}
                            >
                              {t("ui.screens.restaurantSettingsUpdate.disconnectMoloni")}
                            </SecondaryStripeButton>
                          ) : (
                            <ModernButton
                              type="button"
                              disabled={moloniConnectLoading}
                              onClick={handleConnectMoloni}
                            >
                              {t("ui.screens.restaurantSettingsUpdate.connectMoloni")}
                            </ModernButton>
                          )}
                        </StripeButtonRow>
                      </MoloniConnectionPanel>

                      {moloniConnectStatus?.connected && (
                        <MoloniConfigBox>
                          <MoloniConfigField>
                            <label>{t("ui.screens.restaurantSettingsUpdate.moloniCompany")}</label>
                            <StyledSelect
                              value={moloniCompanyId}
                              disabled={moloniConnectLoading}
                              onChange={(e) => handleMoloniCompanyChange(e.target.value)}
                            >
                              <option value="">{t("ui.screens.restaurantSettingsUpdate.selectOption")}</option>
                              {moloniCompanies.map((company) => (
                                <option key={company.company_id} value={company.company_id}>
                                  {company.name || company.business_name || `#${company.company_id}`}
                                </option>
                              ))}
                            </StyledSelect>
                          </MoloniConfigField>

                          <MoloniConfigField>
                            <label>{t("ui.screens.restaurantSettingsUpdate.moloniDocumentSeries")}</label>
                            <StyledSelect
                              value={moloniDocumentSetId}
                              disabled={!moloniCompanyId || moloniConnectLoading}
                              onChange={(e) => setMoloniDocumentSetId(e.target.value)}
                            >
                              <option value="">{t("ui.screens.restaurantSettingsUpdate.selectOption")}</option>
                              {moloniDocumentSets.map((item) => (
                                <option key={item.document_set_id} value={item.document_set_id}>
                                  {item.name || `#${item.document_set_id}`}
                                </option>
                              ))}
                            </StyledSelect>
                          </MoloniConfigField>

                          <MoloniConfigField>
                            <label>{t("ui.screens.restaurantSettingsUpdate.moloniPaymentMethod")}</label>
                            <StyledSelect
                              value={moloniPaymentMethodId}
                              disabled={!moloniCompanyId || moloniConnectLoading}
                              onChange={(e) => setMoloniPaymentMethodId(e.target.value)}
                            >
                              <option value="">{t("ui.screens.restaurantSettingsUpdate.moloniPaymentMethodAutomatic")}</option>
                              {moloniPaymentMethods.map((item) => (
                                <option key={item.payment_method_id} value={item.payment_method_id}>
                                  {item.name || `#${item.payment_method_id}`}
                                </option>
                              ))}
                            </StyledSelect>
                          </MoloniConfigField>

                          <MoloniConfigField>
                            <label>{t("ui.screens.restaurantSettingsUpdate.moloniPrepaymentProduct")}</label>
                            <MoloniProductSearchRow>
                              <Input
                                type="text"
                                value={moloniProductSearch}
                                placeholder={t("ui.screens.restaurantSettingsUpdate.moloniProductSearch")}
                                onChange={(e) => setMoloniProductSearch(e.target.value)}
                              />
                              <SecondaryStripeButton
                                type="button"
                                disabled={!moloniCompanyId || moloniConnectLoading}
                                onClick={() => loadMoloniOptions(moloniCompanyId, moloniProductSearch)}
                              >
                                {t("ui.screens.restaurantSettingsUpdate.search")}
                              </SecondaryStripeButton>
                            </MoloniProductSearchRow>
                            <StyledSelect
                              value={moloniProductId}
                              disabled={!moloniCompanyId || moloniConnectLoading}
                              onChange={(e) => setMoloniProductId(e.target.value)}
                            >
                              <option value="">{t("ui.screens.restaurantSettingsUpdate.selectOption")}</option>
                              {moloniProducts.map((item) => (
                                <option key={item.product_id} value={item.product_id}>
                                  {item.name || item.reference || `#${item.product_id}`}
                                </option>
                              ))}
                            </StyledSelect>
                            <small>{t("ui.screens.restaurantSettingsUpdate.moloniProductHint")}</small>
                          </MoloniConfigField>

                          <MoloniConfigActions>
                            <ModernButton
                              type="button"
                              disabled={moloniConnectLoading}
                              onClick={handleSaveMoloniConfiguration}
                            >
                              {t("ui.screens.restaurantSettingsUpdate.saveMoloniConfiguration")}
                            </ModernButton>
                            <SecondaryStripeButton
                              type="button"
                              disabled={!moloniConnectStatus?.ready || moloniConnectLoading}
                              onClick={handleTestMoloni}
                            >
                              {t("ui.screens.restaurantSettingsUpdate.testMoloniConnection")}
                            </SecondaryStripeButton>
                          </MoloniConfigActions>
                        </MoloniConfigBox>
                      )}

                      {moloniConnectError && (
                        <StripeErrorText>{moloniConnectError}</StripeErrorText>
                      )}
                    </BillingModeBlock>

                    <DescriptionLine style={{ marginTop: "12px" }}>
                      {t(
                        "ui.screens.restaurantSettingsUpdate.prepaymentPolicyHint",
                      )}
                    </DescriptionLine>
                    <DescriptionLine>
                      {t(
                        "ui.screens.restaurantSettingsUpdate.prepaymentDirectFunds",
                      )}
                    </DescriptionLine>
                    <DescriptionLine>
                      {t(
                        "ui.screens.restaurantSettingsUpdate.stripePaymentMethodsHint",
                      )}
                    </DescriptionLine>
                  </SettingsCard>
                )}

                {zonesoftStatus?.linked && (
                  <SettingsCard data-compact-settings-card="true">
                    <SectionTitle>
                      {t("ui.screens.restaurantSettingsUpdate.zonesoftTitle")}
                    </SectionTitle>

                    <MoloniConnectionPanel>
                      <div style={{ minWidth: 0, flex: 1 }}>
                        <strong>{t("ui.screens.restaurantSettingsUpdate.zonesoftConnectionTitle")}</strong>
                        <StripeStatusText
                          $connected={Boolean(zonesoftStatus?.store_configured)}
                          $ready={Boolean(
                            zonesoftStatus?.store_configured && zonesoftStatus?.enabled,
                          )}
                        >
                          {!zonesoftStatus?.store_configured
                            ? t("ui.screens.restaurantSettingsUpdate.zonesoftAwaitingStore")
                            : zonesoftStatus?.enabled
                              ? t("ui.screens.restaurantSettingsUpdate.zonesoftActive")
                              : t("ui.screens.restaurantSettingsUpdate.zonesoftPaused")}
                        </StripeStatusText>
                        {zonesoftStatus?.store_configured && (
                          <DescriptionLine>
                            {t("ui.screens.restaurantSettingsUpdate.zonesoftStore")}:{" "}
                            {zonesoftStatus.merchant_serial_number}_
                            {zonesoftStatus.store_number}
                          </DescriptionLine>
                        )}
                        {zonesoftStatus?.last_sync_at && (
                          <DescriptionLine>
                            {t("ui.screens.restaurantSettingsUpdate.zonesoftLastSync")}:{" "}
                            {moment(zonesoftStatus.last_sync_at).format("YYYY-MM-DD HH:mm")}
                          </DescriptionLine>
                        )}
                      </div>
                    </MoloniConnectionPanel>

                    {zonesoftStatus?.last_sync_error && (
                      <StripeErrorText>
                        {t("ui.screens.restaurantSettingsUpdate.zonesoftLastError")}:{" "}
                        {zonesoftStatus.last_sync_error}
                      </StripeErrorText>
                    )}

                    <ToggleRow>
                      <SwitchSlot>
                        <SwitchOnAndOff
                          isOn={zonesoftEnabled}
                          handleToggle={() => setZonesoftEnabled(!zonesoftEnabled)}
                        />
                      </SwitchSlot>
                      <ToggleText>
                        {t("ui.screens.restaurantSettingsUpdate.zonesoftEnabled")}
                        <DescriptionLine>
                          {t("ui.screens.restaurantSettingsUpdate.zonesoftEnabledHint")}
                        </DescriptionLine>
                      </ToggleText>
                    </ToggleRow>

                    <ToggleRow>
                      <SwitchSlot>
                        <SwitchOnAndOff
                          isOn={zonesoftSyncCreate}
                          handleToggle={() => setZonesoftSyncCreate(!zonesoftSyncCreate)}
                        />
                      </SwitchSlot>
                      <ToggleText>{t("ui.screens.restaurantSettingsUpdate.zonesoftSyncCreate")}</ToggleText>
                    </ToggleRow>

                    <ToggleRow>
                      <SwitchSlot>
                        <SwitchOnAndOff
                          isOn={zonesoftSyncUpdate}
                          handleToggle={() => setZonesoftSyncUpdate(!zonesoftSyncUpdate)}
                        />
                      </SwitchSlot>
                      <ToggleText>{t("ui.screens.restaurantSettingsUpdate.zonesoftSyncUpdate")}</ToggleText>
                    </ToggleRow>

                    <ToggleRow>
                      <SwitchSlot>
                        <SwitchOnAndOff
                          isOn={zonesoftSyncCancel}
                          handleToggle={() => setZonesoftSyncCancel(!zonesoftSyncCancel)}
                        />
                      </SwitchSlot>
                      <ToggleText>{t("ui.screens.restaurantSettingsUpdate.zonesoftSyncCancel")}</ToggleText>
                    </ToggleRow>

                    <MoloniConfigBox>
                      <MoloniConfigField>
                        <label>{t("ui.screens.restaurantSettingsUpdate.zonesoftDiscountType")}</label>
                        <StyledSelect
                          value={zonesoftDiscountType}
                          disabled={zonesoftLoading}
                          onChange={(e) => setZonesoftDiscountType(e.target.value)}
                        >
                          <option value="">
                            {t("ui.screens.restaurantSettingsUpdate.zonesoftDiscountNone")}
                          </option>
                          <option value="percent">
                            {t("ui.screens.restaurantSettingsUpdate.zonesoftDiscountPercent")}
                          </option>
                          <option value="value">
                            {t("ui.screens.restaurantSettingsUpdate.zonesoftDiscountValue")}
                          </option>
                        </StyledSelect>
                      </MoloniConfigField>

                      {zonesoftDiscountType && (
                        <MoloniConfigField>
                          <label>{t("ui.screens.restaurantSettingsUpdate.zonesoftDiscountAmount")}</label>
                          <Input
                            type="number"
                            min="0"
                            step="0.01"
                            value={zonesoftDiscountValue}
                            disabled={zonesoftLoading}
                            onChange={(e) => setZonesoftDiscountValue(e.target.value)}
                          />
                          <small>{t("ui.screens.restaurantSettingsUpdate.zonesoftDiscountHint")}</small>
                        </MoloniConfigField>
                      )}

                      <MoloniConfigField>
                        <label>{t("ui.screens.restaurantSettingsUpdate.zonesoftPrint")}</label>
                        <ToggleRow>
                          <SwitchSlot>
                            <SwitchOnAndOff
                              isOn={zonesoftPrintEnabled}
                              handleToggle={() =>
                                setZonesoftPrintEnabled(!zonesoftPrintEnabled)
                              }
                            />
                          </SwitchSlot>
                          <ToggleText>{t("ui.screens.restaurantSettingsUpdate.zonesoftPrintEnabled")}</ToggleText>
                        </ToggleRow>
                        {zonesoftPrintEnabled && (
                          <>
                            <Input
                              type="text"
                              maxLength={255}
                              value={zonesoftPrintTemplate}
                              disabled={zonesoftLoading}
                              placeholder="{pax} pax - {notes}"
                              onChange={(e) => setZonesoftPrintTemplate(e.target.value)}
                            />
                            <small>{t("ui.screens.restaurantSettingsUpdate.zonesoftPrintHint")}</small>
                          </>
                        )}
                      </MoloniConfigField>

                      <MoloniConfigActions>
                        <ModernButton
                          type="button"
                          disabled={zonesoftLoading}
                          onClick={handleSaveZonesoft}
                        >
                          {t("ui.screens.restaurantSettingsUpdate.zonesoftSave")}
                        </ModernButton>
                      </MoloniConfigActions>
                    </MoloniConfigBox>

                    {zonesoftError && <StripeErrorText>{zonesoftError}</StripeErrorText>}
                    {zonesoftSaved && !zonesoftError && (
                      <DescriptionLine>
                        {t("ui.screens.restaurantSettingsUpdate.zonesoftSaved")}
                      </DescriptionLine>
                    )}
                  </SettingsCard>
                )}

                <SettingsCard data-compact-settings-card="true">
                  <SectionTitle>
                    {t("ui.screens.restaurantSettingsUpdate.cadeirasDeBebe")}
                  </SectionTitle>

                  <SettingControlRow>
                    <SettingCopy>
                      <SettingLabel>
                        {t(
                          "ui.screens.restaurantSettingsUpdate.quantasCadeirasDeBebeExistemNoRestaurante",
                        )}
                      </SettingLabel>
                    </SettingCopy>
                    <BlockedFieldWrapper $blocked={isReservationExtrasBlocked}>
                      <NumberStepper
                        value={numberOfBabyChairs}
                        onChange={(value) =>
                          handleChange({
                            target: { name: "number_of_babychairs", value },
                          })
                        }
                        min={0}
                        max={100}
                        disabled={isReservationExtrasBlocked}
                        displayEmpty={isReservationExtrasBlocked}
                      />
                      {isReservationExtrasBlocked && (
                        <BlockedFieldOverlay
                          data-blocked-field-overlay="true"
                          role="button"
                          tabIndex={0}
                          aria-label={t(
                            "ui.screens.restaurantSettingsUpdate.atualizarOPlanoParaConfigurarAs",
                          )}
                          onClick={() =>
                            setShowReservationExtrasUpgradeModal(true)
                          }
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              setShowReservationExtrasUpgradeModal(true);
                            }
                          }}
                        >
                          <FontAwesomeIcon icon={faLock} />
                        </BlockedFieldOverlay>
                      )}
                    </BlockedFieldWrapper>
                  </SettingControlRow>

                  <SettingControlRow>
                    <SettingCopy>
                      <SettingLabel>
                        {t(
                          "ui.screens.restaurantSettingsUpdate.quantasCadeirasPodemSerSolicitadasPorReserva",
                        )}
                      </SettingLabel>
                    </SettingCopy>
                    <BlockedFieldWrapper $blocked={isReservationExtrasBlocked}>
                      <NumberStepper
                        value={limitBabyChairsReservation}
                        onChange={(value) =>
                          handleChange({
                            target: {
                              name: "limit_baby_chairs_reservation",
                              value,
                            },
                          })
                        }
                        min={0}
                        max={100}
                        disabled={isReservationExtrasBlocked}
                        displayEmpty={isReservationExtrasBlocked}
                      />
                      {isReservationExtrasBlocked && (
                        <BlockedFieldOverlay
                          data-blocked-field-overlay="true"
                          role="button"
                          tabIndex={0}
                          aria-label={t(
                            "ui.screens.restaurantSettingsUpdate.atualizarOPlanoParaConfigurarO2",
                          )}
                          onClick={() =>
                            setShowReservationExtrasUpgradeModal(true)
                          }
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              setShowReservationExtrasUpgradeModal(true);
                            }
                          }}
                        >
                          <FontAwesomeIcon icon={faLock} />
                        </BlockedFieldOverlay>
                      )}
                    </BlockedFieldWrapper>
                  </SettingControlRow>
                </SettingsCard>

                {/*             <SettingsCard>
                  <SectionTitle>{t("ui.screens.restaurantSettingsUpdate.atribuicaoAutomaticaDeMesas")}</SectionTitle>

                  <ToggleRow>
                    <SwitchSlot>
                      <SwitchOnAndOff isOn={autoSetTables} handleToggle={() => setAutoSetTables(!autoSetTables)} />
                    </SwitchSlot>

                    <ToggleText>
                      {t("ui.screens.restaurantSettingsUpdate.atribuirMesasAutomaticamenteAsReservas")}
                      <DescriptionLine>{t("ui.screens.restaurantSettingsUpdate.soupDistribuiReservasPelasMesasDisponiveis")}</DescriptionLine>
                    </ToggleText>
                  </ToggleRow>
                </SettingsCard> */}

                <SettingsCard data-compact-settings-card="true">
                  <SectionTitle>
                    {t(
                      "ui.screens.restaurantSettingsUpdate.notificacaoTempoEstimadoEsgotado",
                    )}
                  </SectionTitle>

                  <ToggleRow>
                    <SwitchSlot>
                      <SwitchOnAndOff
                        isOn={showTableNotFreedNotification}
                        handleToggle={() =>
                          setShowTableNotFreedNotification(
                            !showTableNotFreedNotification,
                          )
                        }
                      />
                    </SwitchSlot>

                    <ToggleText>
                      {t(
                        "ui.screens.restaurantSettingsUpdate.receberNotificacaoQuandoReservaPassouTempoEstimado",
                      )}
                    </ToggleText>
                  </ToggleRow>
                </SettingsCard>

                <SettingsCard data-compact-settings-card="true">
                  <SectionTitle>
                    {t("ui.screens.restaurantSettingsUpdate.soupAttributionTitle")}
                  </SectionTitle>

                  <ToggleRow>
                    <SwitchSlot>
                      <BlockedFieldWrapper $blocked={isSoupAttributionBlocked}>
                        <SwitchOnAndOff
                          isOn={!isSoupAttributionBlocked && !hideSoupAttribution}
                          handleToggle={() => {
                            if (isSoupAttributionBlocked) {
                              setShowPeopleLimitUpgradeModal(true);
                              return;
                            }
                            setHideSoupAttribution(!hideSoupAttribution);
                          }}
                        />
                        {isSoupAttributionBlocked && (
                          <BlockedFieldOverlay
                            data-blocked-field-overlay="true"
                            role="button"
                            tabIndex={0}
                            aria-label={t(
                              "ui.screens.restaurantSettingsUpdate.soupAttributionLocked",
                            )}
                            onClick={() => setShowPeopleLimitUpgradeModal(true)}
                            onKeyDown={(event) => {
                              if (event.key === "Enter" || event.key === " ") {
                                event.preventDefault();
                                setShowPeopleLimitUpgradeModal(true);
                              }
                            }}
                          >
                            <FontAwesomeIcon icon={faLock} />
                          </BlockedFieldOverlay>
                        )}
                      </BlockedFieldWrapper>
                    </SwitchSlot>

                    <ToggleText>
                      {t("ui.screens.restaurantSettingsUpdate.soupAttributionLabel")}
                      <DescriptionLine>
                        {t(
                          isSoupAttributionBlocked
                            ? "ui.screens.restaurantSettingsUpdate.soupAttributionLocked"
                            : "ui.screens.restaurantSettingsUpdate.soupAttributionHint",
                        )}
                      </DescriptionLine>
                    </ToggleText>
                  </ToggleRow>
                </SettingsCard>

                <SettingsCard data-compact-settings-card="true">
                  <SectionTitle>
                    {t(
                      "ui.screens.restaurantSettingsUpdate.bookingQuestionsTitle",
                    )}
                  </SectionTitle>

                  <ToggleRow>
                    <SwitchSlot>
                      <SwitchOnAndOff
                        isOn={askPetFriendly}
                        handleToggle={() => setAskPetFriendly(!askPetFriendly)}
                      />
                    </SwitchSlot>

                    <ToggleText>
                      {t("ui.screens.restaurantSettingsUpdate.askPetFriendly")}
                      <DescriptionLine>
                        {t(
                          "ui.screens.restaurantSettingsUpdate.askPetFriendlyHint",
                        )}
                      </DescriptionLine>
                    </ToggleText>
                  </ToggleRow>

                  <ToggleRow>
                    <SwitchSlot>
                      <SwitchOnAndOff
                        isOn={askBabyStroller}
                        handleToggle={() =>
                          setAskBabyStroller(!askBabyStroller)
                        }
                      />
                    </SwitchSlot>

                    <ToggleText>
                      {t("ui.screens.restaurantSettingsUpdate.askBabyStroller")}
                      <DescriptionLine>
                        {t(
                          "ui.screens.restaurantSettingsUpdate.askBabyStrollerHint",
                        )}
                      </DescriptionLine>
                    </ToggleText>
                  </ToggleRow>
                </SettingsCard>

                <SettingsCard data-compact-settings-card="true">
                  <SectionTitle>
                    {t("ui.screens.restaurantSettingsUpdate.fusoHorario")}
                  </SectionTitle>

                  <StyledSelect
                    value={timezone}
                    onChange={(e) => setTimezone(e.target.value)}
                  >
                    {timezones.map((tz) => (
                      <option key={tz} value={tz}>
                        {tz}
                      </option>
                    ))}
                  </StyledSelect>
                </SettingsCard>
              </SettingsGrid>

              {errorMessage !== "ok_status" && (
                <div
                  style={{
                    color: "red",
                    marginBottom: "10px",
                  }}
                >
                  {errorMessage}
                </div>
              )}

              <SaveBar>
                <ModernButton color="#EE754C" fontSize="12px" type="submit">
                  {t("ui.screens.restaurantSettingsUpdate.guardar")}
                </ModernButton>
              </SaveBar>
        </Form>
      ) : null}

      <CustomModal
        show={showPeopleLimitUpgradeModal}
        onHide={() => setShowPeopleLimitUpgradeModal(false)}
        title={t(
          "ui.screens.restaurantSettingsUpdate.limiteDePessoasPorReserva",
        )}
        body={
          <p
            style={{
              margin: 0,
            }}
          >
            {t(
              "ui.screens.restaurantSettingsUpdate.aConfiguracaoDoNumeroMaximoDe",
            )}
          </p>
        }
        footer={
          <>
            <ModernButton
              color="#99b0ad"
              onClick={() => setShowPeopleLimitUpgradeModal(false)}
            >
              {t("ui.screens.restaurantSettingsUpdate.agoraNao")}
            </ModernButton>

            <ModernButton
              color="#ee754c"
              onClick={() => {
                setShowPeopleLimitUpgradeModal(false);
                navigate(`/pick_plan_and_pay/${restaurants?.id}`);
              }}
            >
              {t("ui.screens.restaurantSettingsUpdate.verPlanos")}
            </ModernButton>
          </>
        }
      />

      <CustomModal
        show={showReservationExtrasUpgradeModal}
        onHide={() => setShowReservationExtrasUpgradeModal(false)}
        title={t("ui.screens.restaurantSettingsUpdate.extrasDaReserva")}
        body={
          <p
            style={{
              margin: 0,
            }}
          >
            {t(
              "ui.screens.restaurantSettingsUpdate.aConfiguracaoDeExtrasDaReserva",
            )}
          </p>
        }
        footer={
          <>
            <ModernButton
              color="#99b0ad"
              onClick={() => setShowReservationExtrasUpgradeModal(false)}
            >
              {t("ui.screens.restaurantSettingsUpdate.agoraNao2")}
            </ModernButton>

            <ModernButton
              color="#ee754c"
              onClick={() => {
                setShowReservationExtrasUpgradeModal(false);
                navigate(`/pick_plan_and_pay/${restaurants?.id}`);
              }}
            >
              {t("ui.screens.restaurantSettingsUpdate.verPlanos2")}
            </ModernButton>
          </>
        }
      />

      <CustomModal
        show={showGroupSizeAcceptanceUpgradeModal}
        onHide={() => setShowGroupSizeAcceptanceUpgradeModal(false)}
        title={t(
          "ui.screens.restaurantSettingsUpdate.aceitacaoPorTamanhoDoGrupo",
        )}
        body={
          <p
            style={{
              margin: 0,
            }}
          >
            {t(
              "ui.screens.restaurantSettingsUpdate.escolherAceitacaoAutomaticaEOuManual",
            )}
          </p>
        }
        footer={
          <>
            <ModernButton
              color="#99b0ad"
              onClick={() => setShowGroupSizeAcceptanceUpgradeModal(false)}
            >
              {t("ui.screens.restaurantSettingsUpdate.agoraNao3")}
            </ModernButton>

            <ModernButton
              color="#ee754c"
              onClick={() => {
                setShowGroupSizeAcceptanceUpgradeModal(false);
                navigate(`/pick_plan_and_pay/${restaurants?.id}`);
              }}
            >
              {t("ui.screens.restaurantSettingsUpdate.verPlanos3")}
            </ModernButton>
          </>
        }
      />

      <CustomModal
        show={showAutoAcceptanceUpgradeModal}
        onHide={() => setShowAutoAcceptanceUpgradeModal(false)}
        title={t(
          "ui.screens.restaurantSettingsUpdate.antecedenciaDaAceitacaoAutomatica",
        )}
        body={
          <p
            style={{
              margin: 0,
            }}
          >
            {t(
              "ui.screens.restaurantSettingsUpdate.asRegrasDeAntecedenciaDaAceitacao",
            )}
          </p>
        }
        footer={
          <>
            <ModernButton
              color="#99b0ad"
              onClick={() => setShowAutoAcceptanceUpgradeModal(false)}
            >
              {t("ui.screens.restaurantSettingsUpdate.agoraNao4")}
            </ModernButton>

            <ModernButton
              color="#ee754c"
              onClick={() => {
                setShowAutoAcceptanceUpgradeModal(false);
                navigate(`/pick_plan_and_pay/${restaurants?.id}`);
              }}
            >
              {t("ui.screens.restaurantSettingsUpdate.verPlanos4")}
            </ModernButton>
          </>
        }
      />
    </Container>
  );
}
export default RestaurantSettingsUpdate;
const SettingsPageHeader = styled(PageHeaderBar)`
  /* The title and its description stack, so the bar wraps around them rather
     than putting them side by side. No rule: the description already separates
     the heading from the page, and a line under it only boxed it in. */
  display: block;
  max-width: 880px;
  border-bottom: 0;
  padding-bottom: 0;
  margin-bottom: 22px;
`;

const SettingsPageTitle = PageHeaderTitle;

const SettingsPageDescription = PageHeaderDescription;

const SettingsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  align-items: stretch;
  gap: 0;
  width: 100%;
  margin-bottom: 28px;
  overflow: visible;
  border-top: 1px solid #e9e6e4;
  border-bottom: 1px solid #e9e6e4;
  border-radius: 0;
  background: #ffffff;
  box-shadow: none;

  > * {
    grid-column: span 6;
  }

  > [data-size-settings-card="true"] {
    grid-column: span 4;
  }

  > [data-auto-settings-card="true"] {
    grid-column: span 8;
    border-left: 1px solid #efedeb;
  }

  > [data-wide-settings-card="true"] {
    grid-column: span 12;
    border-top: 1px solid #efedeb;
  }

  > [data-compact-settings-card="true"] {
    grid-column: span 4;
    border-top: 1px solid #efedeb;
  }

  > [data-compact-settings-card="true"]
    + [data-compact-settings-card="true"] {
    border-left: 1px solid #efedeb;
  }

  @media (max-width: 1180px) {
    > [data-size-settings-card="true"],
    > [data-auto-settings-card="true"] {
      grid-column: span 12;
    }

    > [data-compact-settings-card="true"] {
      grid-column: span 12;
    }

    > [data-auto-settings-card="true"] {
      border-top: 1px solid #efedeb;
      border-left: 0;
    }

    > [data-compact-settings-card="true"]
      + [data-compact-settings-card="true"] {
      border-left: 0;
    }
  }

  @media (max-width: 760px) {
    grid-template-columns: minmax(0, 1fr);

    > * {
      grid-column: 1 !important;
    }
  }
`;

const SettingsCard = styled(BaseSettingsCard)`
  height: 100%;
  min-width: 0;
  padding: clamp(20px, 1.8vw, 26px);
  gap: 18px;
  border: 0;
  border-radius: 0;
  box-shadow: none;

  &[data-wide-settings-card="true"] {
    gap: 14px;
  }

  ${StepperRuleGroup} {
    gap: 8px;
    padding: 6px 0 0;
    border: 0;
    background: transparent;
  }

  ${StepperRule} {
    display: grid;
    grid-template-columns: minmax(170px, 1fr) auto minmax(56px, auto);
    gap: 12px;
    padding: 10px 0;
    border-bottom: 1px solid #f0edeb;
    font-size: 12px;

    &:last-child {
      border-bottom: 0;
      padding-bottom: 0;
    }
  }

  @media (max-width: 576px) {
    padding: 18px;

    ${StepperRule} {
      grid-template-columns: minmax(0, 1fr) auto;

      > :first-child {
        grid-column: 1 / -1;
      }
    }
  }
`;

const SectionTitle = styled(BaseSectionTitle)`
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 0;
  border: 0;
  color: #33282a;
  font-size: 15px;
  font-weight: 750;
  letter-spacing: -0.025em;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    flex: 0 0 8px;
    border-radius: 50%;
    background: #ee754c;
    box-shadow: 0 0 0 5px rgba(238, 117, 76, 0.1);
  }
`;

const SettingControlRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 11px;
  min-width: 0;

  & + & {
    padding-top: 16px;
    border-top: 1px solid #f0ebe5;
  }

  @media (max-width: 620px) {
    grid-template-columns: minmax(0, 1fr) auto;

    > :first-child {
      grid-column: 1 / -1;
    }
  }
`;

const SettingCopy = styled.div`
  min-width: 0;
`;

const SettingLabel = styled.div`
  color: #44383a;
  font-size: 12px;
  font-weight: 650;
  line-height: 1.45;
`;

const SettingUnit = styled.span`
  color: #837b7d;
  font-size: 11px;
  font-weight: 600;
`;

const SettingsIntro = styled.p`
  margin: -8px 0 0;
  color: #756a6c;
  font-size: 12px;
  line-height: 1.55;
`;

const SaveBar = styled.div`
  position: static;
  display: flex;
  justify-content: flex-end;
  padding: 22px 0 8px;
  margin-top: 4px;
  border-top: 1px solid #efedeb;
  background: #ffffff;
`;

const DescriptionLine = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 0.92em;
  opacity: 0.8;
`;

const CurrencySuffix = styled.span`
  display: inline-block;
  margin-left: 6px;
  white-space: nowrap;
`;

const Form = styled.form`
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0;
`;
const BlockedFieldWrapper = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  border-radius: 11px;

  ${({ $blocked }) =>
    $blocked
      ? `
        background: rgba(238, 117, 76, 0.08);
        box-shadow: 0 0 0 2px rgba(238, 117, 76, 0.22);

        input,
        select,
        textarea {
          border-color: #EE754C !important;
          background-color: #fff7f4 !important;
          box-shadow: none !important;
        }

        > *:not([data-blocked-field-overlay="true"]) {
          pointer-events: none;
        }
      `
      : ""}
`;
const BlockedFieldOverlay = styled.span`
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
  color: #ee754c;
  cursor: pointer;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.01);

  svg {
    filter: drop-shadow(0 1px 1px rgba(255, 255, 255, 0.85));
  }
`;
const BlockedSettingText = styled(Text)`
  position: relative;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;
const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-width: 0;
`;
const SwitchSlot = styled.div`
  flex: 0 0 48px;
  width: 48px;
  min-width: 48px;
  max-width: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  & > * {
    flex-shrink: 0;
  }
`;
const ToggleText = styled(Text)`
  flex: 1 1 auto;
  min-width: 0;
  margin: 0 !important;
  line-height: 1.35;
`;
const BillingModeBlock = styled.div`
  margin-top: 18px;
  padding: 18px 0 0;
  border: 0;
  border-top: 1px solid #ece9e7;
  border-radius: 0;
  background: transparent;
  display: flex;
  flex-direction: column;
  gap: 9px;
`;

const BillingModeTitle = styled.div`
  color: #44383a;
  font-size: 12px;
  font-weight: 700;
`;

const BillingModeOption = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin: 0;
  padding: 10px 0;
  border: 0;
  border-bottom: 1px solid #f0edeb;
  border-radius: 0;
  background: transparent;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  opacity: ${({ $disabled }) => ($disabled ? 0.68 : 1)};

  input {
    margin-top: 2px;
    accent-color: #ee754c;
  }

  span {
    display: flex;
    flex-direction: column;
    gap: 3px;
    color: #44383a;
    font-size: 12px;
  }

  small {
    color: #7b8986;
    font-size: 10px;
    line-height: 1.35;
  }
`;

const MoloniConnectionPanel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 4px;
  padding: 12px 0 0;
  border: 0;
  border-radius: 0;
  background: transparent;

  @media (max-width: 600px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

const MoloniConfigBox = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  padding: 14px 0 0;
  border: 0;
  border-top: 1px solid #efedeb;
  border-radius: 0;
  background: transparent;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

const MoloniConfigField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;

  label {
    margin: 0;
    color: #455552;
    font-size: 12px;
    font-weight: 700;
  }

  small {
    color: #7b8986;
    font-size: 11px;
    line-height: 1.35;
  }
`;

const MoloniProductSearchRow = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;

  > input {
    flex: 1 1 auto;
    min-width: 0;
  }
`;

const MoloniConfigActions = styled.div`
  grid-column: 1 / -1;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const StripeConnectionPanel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 0 18px;
  border: 0;
  border-bottom: 1px solid #ece9e7;
  border-radius: 0;
  background: transparent;

  @media (max-width: 600px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;
const StripeStatusText = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 11px;
  color: ${({ $ready, $connected }) =>
    $ready ? "#27815f" : $connected ? "#9a6500" : "#666"};
`;
const StripeButtonRow = styled.div`
  flex-shrink: 0;
`;
const SecondaryStripeButton = styled.button`
  min-height: 34px;
  border: 1px solid #ded9d7;
  background: #fff;
  color: #554a4c;
  border-radius: 8px;
  padding: 6px 11px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`;
const StripeErrorText = styled.div`
  margin-top: 8px;
  color: #b42318;
  font-size: 11px;
`;
const PrepaymentFields = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0;
  margin-top: 2px;
  padding: 14px 0;
  border-top: 1px solid #f0edeb;
  border-bottom: 1px solid #f0edeb;
  opacity: ${({ $disabled }) => ($disabled ? 0.65 : 1)};

  > span {
    min-width: 0;
    min-height: 62px;
    margin: 0;
    padding: 8px 16px;
    border: 0;
    border-left: 1px solid #efedeb;
    border-radius: 0;
    background: transparent;
  }

  > span:first-child {
    padding-left: 0;
    border-left: 0;
  }

  @media (max-width: 1180px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));

    > span:nth-child(odd) {
      padding-left: 0;
      border-left: 0;
    }
  }

  @media (max-width: 620px) {
    grid-template-columns: minmax(0, 1fr);

    > span {
      padding: 10px 0;
      border-left: 0;
      border-bottom: 1px solid #f0edeb;
    }

    > span:last-child {
      border-bottom: 0;
    }
  }
`;
const Button = styled.button`
  display: inline-block;
  font-weight: 400;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background-color: #007bff;
  border: 1px solid #007bff;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 4px;

  &:hover {
    background-color: #0069d9;
    border-color: #0062cc;
  }
`;
